import clsx from "clsx";
import styles from "./index.module.scss";
import { useEffect, useRef, useState } from "react";

type TooltipProps = {
  className?: string;
  content: string;
  arrow?: boolean;
  placement?: "top" | "bottom" | "left" | "right";
}

const Tooltip = (props: TooltipProps) => {
  const {
    className,
    content,
    arrow = true,
    placement = "top",
  } = props;

  const rootEleRef = useRef<HTMLSpanElement>(null);
  const [isHover, setIsHover] = useState(false);

  useEffect(() => {
    const parentEle = rootEleRef.current?.parentElement;
    if (parentEle) {
      const mouseenter = () => setIsHover(true);
      const mouseleave = () => setIsHover(false);

      parentEle.addEventListener("mouseenter", mouseenter);
      parentEle.addEventListener("mouseleave", mouseleave);

      return () => {
        parentEle.removeEventListener("mouseenter", mouseenter);
        parentEle.removeEventListener("mouseleave", mouseleave);
      }
    }
  }, []);

  return (
    <span
      ref={rootEleRef}
      className={clsx(
        styles["tooltip"],
        styles[placement],
        isHover && styles["is_hover"],
        arrow && styles["arrow"],
        className,
      )}
    >
      <span
        className={styles["content"]}
      >
        {content}
      </span>
    </span>
  )
}

export default Tooltip;